<div class="content-layout" [brightsideWebFb]="{event_name: 'spending_intro'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'spending_intro' }"
        [skipActionEmit]="false"
        (exitActionHandler)="navigateHome()"
      ></ui-nav-exit-back>
    </div>
    <div pre-title class="mb-sm">
      <img src="../assets/spending_hero.png">
    </div>
    <div header-title>
      <typography-legacy title-medium>
        {{ 'SPENDING_INTRO_TITLE' | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <typography-legacy>{{ 'SPENDING_INTRO_DESC' | translate }}</typography-legacy>
      <typography-legacy class="mt-sm">{{ 'SPENDING_INTRO_SUBHEADER' | translate }}</typography-legacy>
      <div class="mt-sm">
        <div *ngFor="let reason of introReasons" class="flex-row space-between">
          <div class="align-left mr-sm">
            <bw-icon-legacy [iconName]="'checkmark'" size="24"></bw-icon-legacy>
          </div>
          <div class="flex-column flex-item-flexible">
            <typography-legacy text-medium-regular>{{reason.key|translate}}</typography-legacy>
          </div>
        </div>
      </div>

    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'spending_intro'}"
        (click)="routeUser();">
        {{ 'GET_STARTED' | translate }}
      </button>
      <button
        bw-link-button-legacy
        (click)="showLearnMore = true"
      >
        {{ 'LEARN_MORE' | translate}}
      </button>
    </div>

  </bw-action-article-legacy>
</div>


<bw-modal-legacy *ngIf="showLearnMore"
          [modalWidth]="'large'"
          [showCloseButton]="true"
          (closeModal)="showLearnMore=false"
>
  <typography-legacy title-medium>{{ 'LEARN_MORE' | translate }}</typography-legacy>

  <section class="body">
    <typography-legacy
      text-medium-regular
      color="var(--secondary-text)"
      class="mb-sm">{{'FAQ'|translate}}</typography-legacy>
    <typography-legacy text-medium-semibold
                class="mb-sm">{{'SPENDING_ACCOUNT'|translate}}</typography-legacy>
    <bw-paragraph-legacy *ngFor="let lm of learnMoreContentCount">
      <typography-legacy
        text-small-semibold
        color="var(--secondary-text)"
        class="mb-xs">
        <div [innerHTML]="'SPENDING_FAQ_' + lm | translate"></div>
      </typography-legacy>
      <typography-legacy text-small-regular color="var(--secondary-text)">
        <div [innerHTML]="'SPENDING_FAQ_' + lm + '_DESC' | translate"></div>
      </typography-legacy>
    </bw-paragraph-legacy>
  </section>
</bw-modal-legacy>
